import { render } from "./GKObjectItem.vue?vue&type=template&id=83b9fe58&scoped=true"
import script from "./GKObjectItem.vue?vue&type=script&lang=js"
export * from "./GKObjectItem.vue?vue&type=script&lang=js"

import "./GKObjectItem.vue?vue&type=style&index=0&id=83b9fe58&scoped=true&lang=css"

import exportComponent from "/home/runner/work/estate-boost-frontend/estate-boost-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83b9fe58"]])

export default __exports__